module.exports = __webpack_public_path__ + "img/67.9.TU.708f9aa2.png";